import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SetupResellerRewardPageRoutingModule } from './setup-reseller-reward-routing.module';

import { SetupResellerRewardPage } from './setup-reseller-reward.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SetupResellerRewardPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [SetupResellerRewardPage]
})
export class SetupResellerRewardPageModule {}
